import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";

const options = [
	{ value : 'previousMonthRollOver', display : 'Rollover from Previous Month', },
	{ value : 'interTankTransfer', display : 'Inter Tank Transfer', },
	{ value : 'other', display : 'Other', },
];

class FMPAllocationReasonPicker extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, disabled,
			contained,
			disabledValues, disabledNote,
		} = this.props;

		//- Used to grey out 'Rollover from Previous Month' when the FMP already calculates the
		//- rollover for the chosen terminal / supplier / product / month. The reason stays
		//- visible with an explanation rather than disappearing, so it is obvious why it is
		//- unavailable instead of the option just not being there.
		const shownOptions = options.map((option) => {
			if (!_.includes(disabledValues, option.value)) {
				return option;
			}
			return { ...option, disabled : true, subDisplay : disabledNote };
		});

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={shownOptions}
				onChange={onChange}
				md={md}
				helpText={helpText}
				disabled={disabled}
				contained={contained}
			/>
		);
	}
}

FMPAllocationReasonPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	productTypes : PropTypes.array,
	disabled : PropTypes.bool,

	dataDumpMap : PropTypes.object,
	contained : PropTypes.bool,

	disabledValues : PropTypes.array,
	disabledNote : PropTypes.string,
};

FMPAllocationReasonPicker.defaultProps =  {
	md : 12,
	label : 'Allocation Reason',
	disabledValues : [],
};

export default FMPAllocationReasonPicker;
